import $http from '../../axios';

export async function fetchDocumentByCufe({ commit }, cufe) {
    commit('setLoading', true);
    commit('setError', null);
    
    await $http.get(`/api/public/documento-por-cufe/${cufe}`)
        .then(response => {
            if (response.data && response.data.data) {
                const responseData = response.data.data;
                const document = responseData.document;
                
                commit('setDocument', document);
                commit('setShowModal', true);
            } else {
                commit('setError', 'Documento no encontrado');
            }
        })
        .catch(error => {
            console.error('Error fetching document:', error);
            commit('setError', 'Error al obtener el documento. Verifique que el CUFE sea correcto.');
        })
        .finally(() => {
            commit('setLoading', false);
        });
}

export function closeModal({ commit }) {
    commit('setShowModal', false);
    commit('setDocument', null);
}



// WEBPACK FOOTER //
// ./src/modules/public-invoice/actions.js